import * as Yup from 'yup';

export const invoiceStatementValidation = ({ t }) => {
  return Yup.object().shape({
    typeOfView: Yup.string().required(
      t('invoice_statement.type_of_view_required'),
    ),
    emailAddress: Yup.string()
      .required(t('invoice_statement.email_required'))
      .email(t('invoice_statement.email_invalid')),
    startDate: Yup.string().required(
      t('invoice_statement.start_date_required'),
    ),
    endDate: Yup.string().required(t('invoice_statement.end_date_required')),
  });
};
